var _rect, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenRx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8.57143,
    transform: "matrix(-1 0 0 1 36 0)",
    fill: "#22003C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0357 26.3139C22.5082 26.3139 15.4737 29.3094 12.8974 30.8071C10.8249 31.8342 10.0176 30.3792 9.87302 29.5233C9.87302 22.3341 6.73655 15.6157 5.16831 13.1551C4.36181 11.6145 5.50436 10.5875 6.17645 10.2666C15.3169 9.75305 21.4105 6.84315 23.3148 5.45239C25.7343 4.68212 26.5632 6.20126 26.6752 7.05712C26.944 13.9896 30.1477 21.0718 31.7159 23.7463C32.5224 25.5436 30.9318 26.2069 30.0357 26.3139Z",
    stroke: "#9870FF",
    strokeOpacity: 0.4,
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9675 31.6662C15.1555 26.4594 8.48904 23.5986 5.75734 22.8191C3.68867 22.073 4.22635 20.5407 4.75377 19.8678C9.96049 15.0558 12.8213 8.38937 13.6008 5.65765C14.201 4.06864 15.6752 4.17151 16.3373 4.42158C22.5523 10.4003 28.5553 12.6676 30.7798 13.0539C32.8844 14.2119 32.3141 15.8021 31.7658 16.4524C26.9169 21.2785 23.8357 28.2349 22.9011 31.1098C22.115 32.8707 20.6178 32.2144 19.9675 31.6662Z",
    stroke: "#9870FF",
    strokeOpacity: 0.4,
    strokeWidth: 1.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_604_25213)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_25213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18V15C15.75 14.4033 15.9871 13.831 16.409 13.409C16.831 12.9871 17.4033 12.75 18 12.75C18.5967 12.75 19.169 12.9871 19.591 13.409C20.0129 13.831 20.25 14.4033 20.25 15V18C20.25 18.5967 20.0129 19.169 19.591 19.591C19.169 20.0129 18.5967 20.25 18 20.25C17.4033 20.25 16.831 20.0129 16.409 19.591C15.9871 19.169 15.75 18.5967 15.75 18ZM21.75 18C21.75 17.9005 21.7105 17.8052 21.6402 17.7348C21.5698 17.6645 21.4745 17.625 21.375 17.625C21.2755 17.625 21.1802 17.6645 21.1098 17.7348C21.0395 17.8052 21 17.9005 21 18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21C17.2044 21 16.4413 20.6839 15.8787 20.1213C15.3161 19.5587 15 18.7956 15 18C15 17.9005 14.9605 17.8052 14.8902 17.7348C14.8198 17.6645 14.7245 17.625 14.625 17.625C14.5255 17.625 14.4302 17.6645 14.3598 17.7348C14.2895 17.8052 14.25 17.9005 14.25 18C14.2511 18.9293 14.5968 19.8252 15.2202 20.5144C15.8436 21.2036 16.7005 21.6372 17.625 21.7313V23.25C17.625 23.3495 17.6645 23.4448 17.7348 23.5152C17.8052 23.5855 17.9005 23.625 18 23.625C18.0995 23.625 18.1948 23.5855 18.2652 23.5152C18.3355 23.4448 18.375 23.3495 18.375 23.25V21.7313C19.2995 21.6372 20.1564 21.2036 20.7798 20.5144C21.4032 19.8252 21.7489 18.9293 21.75 18Z",
    fill: "#CCB7FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_604_25213",
    x: 4,
    y: 4.5,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289653 0 0 0 0 0.179688 0 0 0 0 0.375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_604_25213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_604_25213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_25213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenRx);
export default __webpack_public_path__ + "static/media/gen-rx.f144228ad800325f55a062981717dd97.svg";
export { ForwardRef as ReactComponent };